var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaneDownRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.855,
    height: 27.855,
    viewBox: "0 0 27.855 27.855",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2696",
    "data-name": "Group 2696",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40754",
    "data-name": "Path 40754",
    d: "M23.665,1.7h0A.63.63,0,0,0,23.176.539l-8.8,2.927L16.019.777a.51.51,0,0,0-.67-.719l-1.727.9a.508.508,0,0,0-.133.1L8.374,6.4,2.061,9.7C-.329,10.981-.052,11.972.089,12.245a1.348,1.348,0,0,0,.9.645,5.364,5.364,0,0,0,2.289-.037,2.962,2.962,0,0,1,.7-.049c.679.019,1.137-.026,3.413-1.208l12.447-6.47,4.827,2.505a.63.63,0,0,0,.581,0l.813-.423a.63.63,0,0,0,.2-.953l-3.35-4.173Z",
    transform: "translate(18.666 27.856) rotate(-135)",
    fill: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40755",
    "data-name": "Path 40755",
    d: "M13.544,282.5H37.109c.663,0,1.2.328,1.2.732s-.537.732-1.2.732H13.544c-.663,0-1.2-.328-1.2-.732S12.881,282.5,13.544,282.5Z",
    transform: "translate(-12.073 -258.7)",
    fill: "#5f5f5f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneDownRight);
export default __webpack_public_path__ + "static/media/plane-down-right.38e79138.svg";
export { ForwardRef as ReactComponent };